module.exports = __webpack_public_path__ + "8bae8cfe878095a907fdf57cb0828514.pdf";